<template>
  <v-layout>
    <v-flex xs12 sm11 offset-sm1>
      <v-layout row v-if="error">
        <v-flex xs12>
          <app-alert v-if="hasProAccess" @dismissed="onDismissed" :text="error.message" :color="error.colour"></app-alert>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 >
          <bank-integration/>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import BankIntegration from '@/components/Shared/BankIntegration'
export default {
  components: {
    BankIntegration
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    hasProAccess () {
      return this.$store.getters.hasProAccess
    }
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  },
  created () {
    this.$store.dispatch('reloadGroup')
  }
}
</script>
